import {
	ElMessage,
} from 'element-plus'
export default {
	copy(text) {
		if (!text.trim()) {
			ElMessage.error('复制内容为空');
			return;
		}

		// 使用现代浏览器支持的 Clipboard API
		navigator.clipboard.writeText(text.trim())
			.then(() => {
				ElMessage.success('复制成功');
			})
			.catch((err) => {
				ElMessage.error('复制失败，请重试');
				console.log(err)
			});
	}

}